import React from 'react';
import PropTypes from 'prop-types';
import DispatchModalList from './DispatchModalList';

const DispatchToolboxesList = ({
  toolboxes,
  trucks,
  handleUpdateModalState,
  selectedToolboxes,
  occupiedToolboxes,
}) => {
  const columns = [{ selector: 'name', title: 'Coffres', type: 'string' }];

  const MAX_VCS = 6;

  function handleItemClick(item) {
    let newToolboxes = [...selectedToolboxes];
    if (selectedToolboxes.find(toolBoxID => toolBoxID === item.id)) {
      newToolboxes = newToolboxes.filter(toolBoxID => toolBoxID !== item.id);
    } else if (selectedToolboxes.length + trucks.length < MAX_VCS) {
      newToolboxes.push(item.id);
    }

    handleUpdateModalState({ toolboxes: newToolboxes });
  }

  return (
    <DispatchModalList
      data={toolboxes}
      selected={selectedToolboxes}
      columns={columns}
      onClick={handleItemClick}
      highlighted={occupiedToolboxes}
    />
  );
};

DispatchToolboxesList.propTypes = {
  toolboxes: PropTypes.array,
  handleUpdateModalState: PropTypes.func,
  selectedToolboxes: PropTypes.array,
};

export default DispatchToolboxesList;
